import { create } from 'zustand'

interface AuthState {
    auth: {
        login: boolean
        verify: boolean
        name?: string
        email?: string
        phone?: string
        role?: string
    }
}

interface NavbarState {
    dialog: {
        closable: boolean
        open: boolean
    }
}

interface VerifyState {
    verify: {
        closable: boolean
        open: boolean
    }
}

interface FeaturedState {
    properties: any[]
}

export interface StoreState extends AuthState, NavbarState, VerifyState, FeaturedState {
    setAuth: (auth: AuthState['auth']) => void
    setDialog: (dialog: NavbarState['dialog']) => void
    setVerify: (verify: VerifyState['verify']) => void
    setProperties: (properties: any[]) => void
}

const useStore = create<StoreState>((set) => ({
    // Auth State
    auth: {
        login: false,
        verify: false
    },
    setAuth: (auth) => set({ auth }),

    // Navbar State
    dialog: {
        closable: true,
        open: false
    },
    setDialog: (dialog) => set({ dialog }),

    // Verify State 
    verify: {
        closable: true,
        open: false
    },
    setVerify: (verify) => set({ verify }),

    // Featured State
    properties: [],
    setProperties: (properties) => set({ properties })
}))

export default useStore;